/**
 * Gradasi nilai untuk peta: kuantil otomatis atau batas manual.
 */

export function quantileBreaks(sortedPositiveValues, tierCount) {
  const values = sortedPositiveValues;
  const nT = Math.max(2, Math.min(8, Number(tierCount) || 4));
  if (!values.length || nT < 2) return [];
  const breaks = [];
  for (let i = 1; i < nT; i++) {
    const idx = Math.floor((i * values.length) / nT);
    breaks.push(values[Math.min(idx, values.length - 1)]);
  }
  for (let i = 1; i < breaks.length; i++) {
    if (breaks[i] <= breaks[i - 1]) {
      breaks[i] = breaks[i - 1] + Number.EPSILON * (i + 1);
    }
  }
  return breaks;
}

/**
 * @param {number} val
 * @param {number[]} breaks ascending, length tierCount - 1
 * @param {number} tierCount
 * @returns {-1} tidak ada data; 0..tierCount-1 gradasi
 */
export function valueToTierIndex(val, breaks, tierCount) {
  const nT = Math.max(2, Math.min(8, Number(tierCount) || 4));
  const b = Array.isArray(breaks) ? breaks.filter((x) => Number.isFinite(x)) : [];
  if (val == null || val <= 0 || !Number.isFinite(val)) return -1;
  if (b.length !== nT - 1) return -1;
  for (let i = 0; i < b.length; i++) {
    if (val <= b[i]) return i;
  }
  return nT - 1;
}

export function ensureTierPalette(palette, tierCount, fallbackColors) {
  const nT = Math.max(2, Math.min(8, Number(tierCount) || 4));
  const fb = fallbackColors || ['#90caf9', '#42a5f5', '#1976d2', '#0d47a1'];
  const base = Array.isArray(palette) && palette.length ? [...palette] : [...fb];
  while (base.length < nT) {
    base.push(base[base.length - 1] || '#1976d2');
  }
  if (base.length > nT) base.length = nT;
  return base;
}

export function ensureManualBreaks(breaks, tierCount) {
  const nT = Math.max(2, Math.min(8, Number(tierCount) || 4));
  const need = nT - 1;
  const arr = Array.isArray(breaks) ? breaks.map((x) => Number(x)).filter((x) => Number.isFinite(x)) : [];
  while (arr.length < need) arr.push(arr.length ? arr[arr.length - 1] + 1 : 1);
  if (arr.length > need) arr.length = need;
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] <= arr[i - 1]) arr[i] = arr[i - 1] + 1e-6;
  }
  return arr;
}

export function legendLabelsForTiers(breaks, tierCount, isPercent) {
  const nT = Math.max(2, Math.min(8, Number(tierCount) || 4));
  const b = Array.isArray(breaks) ? breaks : [];
  const labels = [];
  if (b.length !== nT - 1) {
    for (let i = 0; i < nT; i++) {
      labels.push('—');
    }
    return labels;
  }
  const fmt = (x) => (isPercent ? `${Number(x).toFixed(1)}%` : `${numberFmt(x)}`);
  labels.push(`≤ ${fmt(b[0])}`);
  for (let i = 1; i < b.length; i++) {
    labels.push(`${fmt(b[i - 1])} – ${fmt(b[i])}`);
  }
  labels.push(`> ${fmt(b[b.length - 1])}`);
  return labels;
}

function numberFmt(x) {
  const n = Number(x);
  if (!Number.isFinite(n)) return '—';
  if (Math.abs(n - Math.round(n)) < 1e-9) return String(Math.round(n));
  return n.toFixed(2).replace(/\.?0+$/, '');
}
